import { Link } from "react-router-dom";

import servicesHero from "../images/services_hero.svg";
import itStrategyandConsulting from "../images/services/ITStrategyandConsulting.png";
import cloudServices from "../images/services/CloudServices.png";
import cyberSecurity from "../images/services/CyberSecuritySolutions.png";
import appDev from "../images/services/AppDev.png";
import dataAnalytics from "../images/services/DataAnalytics.png";
import iTInfrastructure from "../images/services/ITInfrastructure.png";

export const Services = () => {
  return (
    <>
      <div className="pageHero">
        <div className="pageHeroText">
          <h1 className="pageHeroTitle">Services</h1>
          <p className="pageHeroSubtitle">
            Comprehensive IT solutions designed to modernize your operations,
            secure your infrastructure, and unlock the power of AI.
          </p>
        </div>
        <div className="pageHeroImageWrap hide-on-mobile">
          <img src={servicesHero} alt="IT Services" className="pageHeroImg" />
        </div>
      </div>

      <div className="pageContent">

        <div className="serviceSection">
          <h3 className="sectionTitle" style={{ display: "block", textAlign: "center", borderBottom: "none", paddingBottom: 0 }}>AI-Powered Services</h3>
          <p style={{ maxWidth: "700px", margin: "4px auto 28px", textAlign: "center" }}>
            We bring enterprise-grade artificial intelligence to organizations of
            every size, from proof of concept through production deployment.
          </p>
          <div className="aiCardsRow">
            <div className="aiFeatureCard">
              <h6>Agentic AI &amp; Automation</h6>
              <p>
                LLM-powered agents that handle complex workflows: code review,
                document processing, and decision support, reducing operational
                overhead and time-to-delivery.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>AI Strategy &amp; Readiness</h6>
              <p>
                Assess your organization's AI readiness, identify high-impact use
                cases, and develop a prioritized roadmap to move from
                experimentation to measurable business value.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Responsible AI Governance</h6>
              <p>
                Ethical guardrails, compliance frameworks, and responsible AI
                policies to keep your deployments safe, auditable, and aligned
                with your organization's values.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>AI-Augmented Analytics</h6>
              <p>
                Real-time anomaly detection, predictive dashboards, and
                intelligent alerting embedded directly into your platforms for
                smarter decisions at scale.
              </p>
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="serviceLayout">
            <div className="serviceText">
              <h3 className="sectionTitle">IT Strategy and Consulting</h3>
              <p>
                Transform your business with a forward-thinking IT strategy. Our
                experts collaborate with your team to build a roadmap that drives
                efficiency and sustainable growth.
              </p>
              <ul className="serviceList">
                <li>
                  <strong>Analyze your current IT infrastructure</strong>
                  Assess hardware, software, networks, security, and operations
                  to identify gaps and optimization opportunities.
                </li>
                <li>
                  <strong>Identify areas for improvement and cost savings</strong>
                  Uncover inefficiencies, security risks, and cost-saving
                  opportunities aligned with your business objectives.
                </li>
                <li>
                  <strong>Develop a roadmap for sustainable growth</strong>
                  Align digital transformation initiatives with business goals,
                  prioritize key projects, and ensure scalability.
                </li>
              </ul>
            </div>
            <div className="serviceImage hide-on-mobile">
              <img src={itStrategyandConsulting} alt="IT Strategy and Consulting" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection serviceSectionTinted">
          <div className="serviceLayout reverse">
            <div className="serviceText">
              <h3 className="sectionTitle">Cloud Services</h3>
              <p>
                Harness the power of the cloud with scalable and secure solutions
                tailored to your business needs.
              </p>
              <ul className="serviceList">
                <li>
                  <strong>Cloud migration and deployment</strong>
                  Transfer applications, databases, and workloads to the cloud to
                  enhance agility, reduce costs, and improve business continuity.
                </li>
                <li>
                  <strong>Hybrid and multi-cloud solutions</strong>
                  Balance flexibility, security, and cost efficiency across
                  multiple cloud environments while maintaining control over
                  critical workloads.
                </li>
                <li>
                  <strong>Optimization for cost and performance</strong>
                  Eliminate over-provisioning and hidden cloud costs while
                  maximizing workload efficiency for long-term sustainability.
                </li>
              </ul>
            </div>
            <div className="serviceImage hide-on-mobile">
              <img src={cloudServices} alt="Cloud Services" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="serviceLayout">
            <div className="serviceText">
              <h3 className="sectionTitle">Cybersecurity Solutions</h3>
              <p>
                Protect your business from evolving cyber threats with robust,
                multi-layered security measures.
              </p>
              <ul className="serviceList">
                <li>
                  <strong>Threat assessment and vulnerability analysis</strong>
                  Identify, evaluate, and mitigate risks to IT infrastructure,
                  applications, and data before they become incidents.
                </li>
                <li>
                  <strong>Implementation of advanced security protocols</strong>
                  Deploy robust authentication, encryption, access control, and
                  monitoring to reduce attack surface and meet compliance standards.
                </li>
                <li>
                  <strong>Continuous monitoring and incident response</strong>
                  Proactive real-time threat detection with rapid containment and
                  recovery to minimize downtime and business impact.
                </li>
              </ul>
            </div>
            <div className="serviceImage hide-on-mobile">
              <img src={cyberSecurity} alt="Cybersecurity Solutions" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection serviceSectionTinted">
          <div className="serviceLayout reverse">
            <div className="serviceText">
              <h3 className="sectionTitle">Application Development &amp; Integration</h3>
              <p>
                Stay ahead with custom software and seamless integrations built to
                your exact specifications.
              </p>
              <ul className="serviceList">
                <li>
                  <strong>Bespoke application design and development</strong>
                  Custom solutions tailored to your unique business goals,
                  workflows, and user requirements, built for scalability.
                </li>
                <li>
                  <strong>Integration with existing systems</strong>
                  Modernize operations while leveraging current investments,
                  reducing redundancy and improving cross-system efficiency.
                </li>
                <li>
                  <strong>Support for AI and IoT</strong>
                  Embed intelligent automation, real-time data processing, and
                  predictive decision-making directly into your applications.
                </li>
              </ul>
            </div>
            <div className="serviceImage hide-on-mobile">
              <img src={appDev} alt="Application Development" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="serviceLayout">
            <div className="serviceText">
              <h3 className="sectionTitle">Data Analytics &amp; Business Intelligence</h3>
              <p>
                Unlock the potential of your data to make faster, more confident
                decisions.
              </p>
              <ul className="serviceList">
                <li>
                  <strong>Data visualization and reporting</strong>
                  Transform raw data into intuitive dashboards that reveal
                  patterns, trends, and outliers at a glance.
                </li>
                <li>
                  <strong>Predictive analytics and machine learning</strong>
                  Leverage AI and statistical algorithms to forecast trends,
                  automate decisions, and optimize operations.
                </li>
                <li>
                  <strong>Insights for operational excellence</strong>
                  Business intelligence that reduces inefficiencies, improves
                  customer satisfaction, and drives profitability.
                </li>
              </ul>
            </div>
            <div className="serviceImage hide-on-mobile">
              <img src={dataAnalytics} alt="Data Analytics" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection serviceSectionTinted">
          <div className="serviceLayout reverse">
            <div className="serviceText">
              <h3 className="sectionTitle">IT Infrastructure Services</h3>
              <p>
                Build a robust, secure, and scalable foundation for your entire
                IT environment.
              </p>
              <ul className="serviceList">
                <li>
                  <strong>Network design and implementation</strong>
                  Plan, deploy, and optimize a secure infrastructure that
                  supports business operations and ensures high availability.
                </li>
                <li>
                  <strong>Hardware and software procurement</strong>
                  Strategic acquisition of cost-effective, high-performance IT
                  resources aligned with your compliance and security requirements.
                </li>
                <li>
                  <strong>Disaster recovery and backup solutions</strong>
                  Ensure business continuity with recovery strategies that
                  minimize downtime, data loss, and financial impact.
                </li>
              </ul>
            </div>
            <div className="serviceImage hide-on-mobile">
              <img src={iTInfrastructure} alt="IT Infrastructure" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="calloutBox">
            <h4>Why Choose DOMMICRO?</h4>
            <ul className="calloutList">
              <li><strong>Expertise</strong> Certified professionals with years of cross-industry experience.</li>
              <li><strong>Tailored Solutions</strong> Customized strategies aligned with your business goals.</li>
              <li><strong>Customer-Centric</strong> Your success is our priority, we deliver measurable results.</li>
              <li><strong>Cutting-Edge Technology</strong> The latest tools and AI capabilities to keep you ahead.</li>
            </ul>
            <Link to="/contact" className="calloutCta">Get in Touch</Link>
          </div>
        </div>

      </div>
    </>
  );
};
